// extracted by mini-css-extract-plugin
module.exports = {"loadingMessage":"LoadingMessage_loadingMessage__1lP8J"};